import React from 'react';

import { Handle } from 'reactflow';

import { BlockData, CustomNodeProps } from 'types';
import useDataNode from './hooks/useDataNode';
import Parameter from '../Parameter/Parameter';
import DataNodeHeader from './components/DataNodeHeader';
import { NodeBody, NodeContainer, NodeWrapper } from '../ui';
import useHandlePosition from '../../../hooks/useHandlePosition';

const DataNode = ({ data, id, selected, modelDirection }: CustomNodeProps<BlockData>) => {
  const { onInfoClick } = useDataNode({ prefix: data.prefix });
  const { handlePosition } = useHandlePosition(modelDirection);

  return (
    <NodeWrapper $isSelected={selected}>
      <NodeContainer $color="#B0B0B7">
        <DataNodeHeader data={data} color="#B0B0B7" onInfoClick={onInfoClick} />
        <NodeBody>
          <Parameter
            nodeId={id}
            index={0}
            parameter={{
              param: 'type',
              value: `${data.prefix} data`,
              defaultValue: null,
              type: 'string',
            }}
            isSelected={selected}
            disabled
          />
        </NodeBody>
      </NodeContainer>
      <Handle
        className={`source-handle ${handlePosition.source}`}
        type="source"
        position={handlePosition.source}
        id={`${id}_source`}
      />
    </NodeWrapper>
  );
};

export default React.memo(DataNode);
